import { FIELD_EVALUATION_REPORT_DIALOG_SHOWN_KEY, FIELD_EVALUATION_REPORT_DIALOG_SHOWN_VALUE } from './constants'

export const isFieldEvaluationReportDialogAlreadyShown = () => {
  try {
    return sessionStorage.getItem(FIELD_EVALUATION_REPORT_DIALOG_SHOWN_KEY) === FIELD_EVALUATION_REPORT_DIALOG_SHOWN_VALUE
  } catch (error) {
    return false
  }
}

export const markFieldEvaluationReportDialogAsAlreadyShown = () => {
  try {
    sessionStorage.setItem(FIELD_EVALUATION_REPORT_DIALOG_SHOWN_KEY, FIELD_EVALUATION_REPORT_DIALOG_SHOWN_VALUE)
  } catch (error) {
    // no-op
  }
}
